module.exports = __webpack_public_path__ + "img/edit.aaa136ac.svg";